/* 

Arrivage services

*/


import axios from "../../axios/index.js"


export default {
  // Méhode getAllArrivage pour la récupération d'une liste des articles dans cet arrivage(sans filtre : La liste totale)
    getAllArrivage() {
      return axios.get("/arrivage",
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
    },
    // Méhode getAllArrivageParMagasin pour la récupération d'une liste des articles dans cet arrivage en indiquant le magasin pour chaque article
    getAllArrivageParMagasin() {
      return axios.get("/arrivageParMagasin",
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
    },
      // Méhode getListArrivageParMagasin pour la récupération d'une liste des articles dans cet arrivage seulement dans le magasin pour le client connecté
    getListArrivageParMagasin(code) {
      return axios.get("/listArrivageParMagasin/"+code,
      { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
    },
}
